import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map } from 'rxjs/operators';
import { AppUrls } from '../route/app-urls';
import { ErrorHandlers } from '../shared/helpers/error-handlers';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Message } from './message';
import { MessageDto } from './message-dto';

@Injectable({ providedIn: 'root' })
export class MessageService {
  private http = inject(HttpClient);

  private _messageCount = 0;
  private messageCount$ = new BehaviorSubject(this._messageCount);

  set messageCount(value: number) {
    if (value !== this.messageCount) {
      this._messageCount = value;
      this.messageCount$.next(this._messageCount);
    }
  }

  public getMessages(): Observable<Message[]> {
    return this.http.get<MessageDto[]>(AppUrls.getApiUrl(AppUrls.urlMessage, 'get')).pipe(
      map((dtoList) => this.convertFromDto(dtoList)),

      catchError((error) => {
        return ErrorHandlers.errorHandler(error);
      })
    );
  }

  public deleteMessage(messageId: string): Observable<boolean> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        messageId: messageId,
      },
    };
    return this.http.request<boolean>('delete', AppUrls.getApiUrl(AppUrls.urlMessage, 'delete'), options).pipe(
      map(() => {
        return true;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }

  public deleteAllMessages(): Observable<boolean> {
    return this.http.request<boolean>('delete', AppUrls.getApiUrl(AppUrls.urlMessage, 'deleteall')).pipe(
      map(() => {
        return true;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }

  observe() {
    return this.messageCount$.pipe(distinctUntilChanged());
  }

  private convertFromDto(dtoList: MessageDto[]): Message[] {
    const list: Message[] = [];
    if (dtoList) {
      dtoList.forEach((dto) => {
        console.log(dto);
        const item = Message.fromDto(dto);
        console.log(item);
        list.push(item);
      });
    }
    return list;
  }
}
